import React, { useEffect } from "react";
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import AtomizeForm from "../../Component/AtomizerForm/AtomizerForm";
import "./AtomizerPageStyles.css";
import Box from "@mui/material/Box";
import { store } from "../../Store/store";
import { handleResetState, initailPage } from "../../Action/actions";
import { initialState } from "../../Reducer/atomizerPageReducer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import AllModals from "../../Component/Modals/allModals";
import Layout from '../../NewComponent/LayoutCM/Layout';

function AtomizerPage() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { handlePageRefresh } = bindActionCreators(Actions, dispatch);
  useEffect(() => {
    handlePageRefresh(initialState);
    // store.dispatch(initailPage(onSumbitValueChange));
  }, [location.key]); 
  return (
    <>
      <Layout>
        <AllModals />
        <Box
          sx={{ marginTop: "4%" }}
          // display="flex"
          // flexDirection="column"
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <AtomizeForm />
        </Box>
      </Layout>
    </>
  );
}

export default AtomizerPage;
